export enum ErrorReason {
    NO_CLAIMS = 'No Claims',
    BAD_REGEX = 'Malformed Claim Information',
    NO_INSPECTIONS = 'No Inspections',
    AJAX_ERROR = 'ajax error',
    UNKNOWN = 'unknown',
}

export enum ErrorType {
    VALIDATION_ERROR = 'VALIDATION ERROR',
}
